var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditClassificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13414 0 0 3.13414 0 7C0 10.8659 3.13414 14 7 14C10.8659 14 14 10.8659 14 7C14 3.13414 10.8659 0 7 0ZM3.77727 10.4133C3.75107 10.4196 3.72372 10.419 3.69779 10.4118C3.67186 10.4045 3.64821 10.3907 3.62906 10.3718C3.60991 10.3529 3.5959 10.3294 3.58834 10.3036C3.58078 10.2777 3.57993 10.2504 3.58586 10.2241L3.93695 8.63816L5.32684 10.0352L3.77727 10.4133ZM5.70336 9.65727L4.31348 8.26L7.83262 4.72281L9.22332 6.12008L5.70336 9.65727ZM10.2785 5.06078L9.58562 5.75695L8.19492 4.35969L8.78883 3.76277C8.84581 3.70554 8.91355 3.66012 8.98813 3.62913C9.06272 3.59814 9.14269 3.58219 9.22346 3.58219C9.30422 3.58219 9.3842 3.59814 9.45878 3.62913C9.53337 3.66012 9.6011 3.70554 9.65809 3.76277L10.2785 4.38594C10.3678 4.47553 10.418 4.59687 10.418 4.72336C10.418 4.84985 10.3678 4.97119 10.2785 5.06078Z",
    fill: "#6021B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditClassificationIcon);
export default __webpack_public_path__ + "static/media/editClassificationIcon.a141bad9131884799c2b60455b3c27c1.svg";
export { ForwardRef as ReactComponent };